import * as React from 'react';
import * as Theme from '@sail/theme-classic';
import {view} from '../view';

interface LabelProps {
  /**
   * Used to refer to the id of the form control this input is labeling.
   * @external
   */
  htmlFor?: string;
}

export const Label = view.label.create<LabelProps>(function Label(props, View) {
  return <View uses={[props, Theme.Label]} />;
});
